import { Box, Button } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { Link } from "react-router-dom"
import styled from "styled-components"

import scrollToElement from "helpers/scroll-to-element"

const Grid = styled(Box).attrs((props) => ({
  bg: "white",
  display: "grid",
  gridGap: { _: 2, tablet: "18px" },
  gridTemplateColumns: { _: "1fr 1fr", desktop: "repeat(3, 320px)" },
  justifyContent: "center",
  my: { _: 3, tablet: 5 },
  pb: 4,
  pt: 4,
  px: 2,
  ...props,
}))``

const LinkButton = styled(Button).attrs((props) => ({
  bg: "black",
  color: "white",
  fontSize: { _: "16px", tablet: "20px" },
  fontWeight: "700",
  height: { _: "48px", tablet: "50px" },
  px: 0,
  py: 0,
  underline: true,
  ...props,
}))``

const LandingQuickLinks = ({ element }) => {
  return (
    <Grid {...element.style?.block_style}>
      {element.data.links.map((link, i) => {
        const urlProps = link.url?.startsWith("#")
          ? {
              forwardedAs: "a",
              href: link.url,
              onClick: (e) => {
                e.preventDefault()
                scrollToElement(link.url)
              },
            }
          : {
              forwardedAs: Link,
              to: link.url,
            }

        return (
          <LinkButton
            data-lc={element.anchor_name || element.id}
            key={`${element.id}-${i}-${link.name}`}
            {...element.style?.link_style}
            {...link.style}
            {...urlProps}
          >
            {link.name}
          </LinkButton>
        )
      })}
    </Grid>
  )
}

LandingQuickLinks.propTypes = {
  element: PropTypes.object,
}

export default LandingQuickLinks
